var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSouthAfrica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 40.0001C31.0459 40.0001 40.0003 31.0458 40.0003 20.0001C40.0003 8.95443 31.0459 0.000125885 20.0002 0.000125885C8.95455 0.000125885 0.000244141 8.95443 0.000244141 20.0001C0.000244141 31.0458 8.95455 40.0001 20.0002 40.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85788 34.1422C-1.95259 26.3317 -1.95259 13.6684 5.85788 5.85786C5.85733 5.85872 17.3914 20 17.3914 20L5.85788 34.1422Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3913 20.0001L2.6526 10.0402C2.19564 10.8345 1.79268 11.6635 1.44643 12.5216L8.90807 20.0002L1.44666 27.4791C1.7926 28.3366 2.19518 29.1651 2.65182 29.9588L17.3913 20.0001Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8307 17.3913H17.3908L5.85767 5.85812C4.61486 7.10094 3.53509 8.50648 2.65259 10.0402L12.5931 20L2.65181 29.9586C3.53431 31.4927 4.61454 32.8987 5.85767 34.1418L17.3908 22.6087H39.8307C39.9419 21.7548 40 20.8841 40 20C40 19.1159 39.9419 18.2452 39.8307 17.3913V17.3913Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82318 35.8655C11.1958 38.4578 15.4174 40.0001 19.9999 40.0001C29.2404 40.0001 37.0159 33.7328 39.3109 25.2175H18.4712L7.82318 35.8655Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3109 14.7826C37.0159 6.26731 29.2404 4.57764e-05 19.9999 4.57764e-05C15.4174 4.57764e-05 11.1958 1.54231 7.82318 4.13466L18.4711 14.7826H39.3109Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthAfrica);
export default __webpack_public_path__ + "static/media/south_africa.2dddce29655ca3a7dfa51e0c59444b02.svg";
export { ForwardRef as ReactComponent };